import { useState, FC } from 'react';
import {
  Button,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useNotify } from 'react-admin';

const TOP = 43;
const LEFT = 46;

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '1px #000',
    padding: theme.spacing(2, 4, 3),
    top: `${TOP}%`,
    left: `${LEFT}%`,
    transform: `translate(-${TOP}%, -${LEFT}%)`,
  },
  actionsRow: {
    marginTop: theme.spacing(2),
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
  report?: { id: string; title: string } | null;
  onSubmit?: (args: { dateFrom: string; dateTo: string }) => void | Promise<void>;
  loading?: boolean;
};

export const CsvReportDownloadModal: FC<Props> = ({ open, onClose, report, onSubmit, loading }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [dateFrom, setDateFrom] = useState<string>('');
  const [dateTo, setDateTo] = useState<string>('');
  
  const handleSubmit = async () => {
    if (!report?.id) {
      // Invariant
      notify('Report is not selected', 'warning');
      return;
    }
    if (!dateFrom || !dateTo) {
      notify('Fill both dates', 'warning');
      return;
    }
    if (onSubmit) {
      await onSubmit({ dateFrom, dateTo });
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <div className={classes.paper}>
        <h2>
          Download
          {' '}
          {report?.title}
        </h2>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Date from"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Date to"
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.actionsRow}
          justifyContent="flex-end"
        >
          <Button
            color="primary"
            disabled={!!loading}
            variant="contained"
            onClick={handleSubmit}
          >
            {loading ? 'Downloading...' : 'Download'}
          </Button>
        </Grid>
      </div>
    </Modal>
  );
};
